import { Link, useOutletContext } from "react-router-dom";
import { EmptyImage } from "../../utils/constants";
import { useParams } from "react-router-dom";
import { parseCurrency } from "../../utils/currency";

export default function OrderTableItem({ data }) {
  const { slug } = useParams();
  const { currency } = useOutletContext();

  return (
    <tr>
      <td className="thumbImg">
        <Link
          to={`/${slug}/p/${data?.productId}`}
          className="thumb d-inline-block">
          <img
            className="cart__image"
            src={
              data?.productImageUrl ||
              data?.productImages?.[0]?.productImageUrl ||
              EmptyImage
            }
            alt={data?.productDescription}
            width="80"
          />
        </Link>
      </td>
      <td className="text-start">
        <Link to={`/${slug}/p/${data?.productId}`}>{data?.productName}</Link>
        {!!data?.selectedVariation && (
          <div className="cart__meta-text fw-bold">
            {data?.selectedVariation}
          </div>
        )}
      </td>
      <td>{parseCurrency(data?.productPrice, currency)}</td>
      <td>{data?.unit}</td>
      <td className="fw-500">
        {parseCurrency(data?.unit * data?.productPrice, currency)}
      </td>
    </tr>
  );
}
